@if (progress() > 0) {
  <div class="absolute left-0 z-99999 flex w-full justify-center px-3">
    <div class="w-100 rounded-md bg-white p-3 shadow-lg">
      <div class="mb-1 flex justify-between">
        <span class="text-base font-medium text-blue-700 dark:text-white">
          {{ 'Uploading' | transloco }}
        </span>
        <span class="text-sm font-medium text-blue-700 dark:text-white">{{ progress() }} %</span>
      </div>
      <div class="mb-3 h-2.5 w-full rounded-full bg-gray-200 dark:bg-gray-700">
        <div
          class="h-2.5 rounded-full bg-blue-600"
          id="progress-bar"
          [style]="'width:' + progress() + '%'"
        ></div>
      </div>
    </div>
  </div>
}
